import { createSlice } from '@reduxjs/toolkit';

export interface IThemeSlideColor {
    color: string,
    hover: string
}

export interface ThemeSlideColorSliceState {
    slideColor?: IThemeSlideColor;
}

export const ThemeSlideColorSlice = createSlice({
    name: 'slideColor',
    initialState: {
        slideColor: {
            color: undefined,
            hover: undefined
        }
    },
    reducers: {
        setColor: (state, action) => {
            state.slideColor = action.payload;
        },

        resetColor: (state) => {
            state.slideColor = {
                color: undefined,
                hover: undefined
            }
        }
    },
});

export default ThemeSlideColorSlice
export const ThemeSlideColorActions = ThemeSlideColorSlice.actions
export const ThemeSlideColorSelector = (store: { slideColor: ThemeSlideColorSliceState }): ThemeSlideColorSliceState => store.slideColor;
import { createSlice } from '@reduxjs/toolkit';

export interface IThemeSlideColor {
    color: string,
    hover: string
}

export interface ThemeSlideColorSliceState {
    slideColor?: IThemeSlideColor;
}

export const ThemeSlideColorSlice = createSlice({
    name: 'slideColor',
    initialState: {
        slideColor: {
            color: undefined,
            hover: undefined
        }
    },
    reducers: {
        setColor: (state, action) => {
            state.slideColor = action.payload;
        },

        resetColor: (state) => {
            state.slideColor = {
                color: undefined,
                hover: undefined
            }
        }
    },
});

export default ThemeSlideColorSlice
export const ThemeSlideColorActions = ThemeSlideColorSlice.actions
export const ThemeSlideColorSelector = (store: { slideColor: ThemeSlideColorSliceState }): ThemeSlideColorSliceState => store.slideColor;
